import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GenreMusicalDto } from '@core/models/ce/chant-genre-style-model';
import { ChantUserTextField, ChantUserModel } from '@core/models/cu/chant-user-model';
import { GenreMusicalService } from '@core/service/genre-musical/genre-musical.service';
import { ImportALlModule } from '@shared/imports';

@Component({
  selector: 'app-style-musical-multiselect',
  standalone: true,
  imports: [
    ImportALlModule,
  ],
  templateUrl: './style-musical-multiselect.component.html',
  styleUrl: './style-musical-multiselect.component.scss'
})
export class StyleMusicalMultiselectComponent {

  textField = ChantUserTextField;
  @Input() objChant: ChantUserModel = new ChantUserModel();
  // @Input() showAddButton: boolean=false;
  @Input() genreEtStyleMusicalDataDtoListSelected:GenreMusicalDto[] = [];
  @Input() control!: FormControl;
  // @Output() onChangeGenre = new EventEmitter<any>();

  constructor(public genreMusicalService: GenreMusicalService ){
  }

  public get styleMusicalDataListCount():number {
    return (!this.objChant.genreMusicalListSelected)?0:this.objChant.genreMusicalListSelected.reduce((total, group) => total + group.styleMusicals.length, 0);
  };
}
